import {asyncLoad, asyncDelete, asyncPatch} from './.';

import * as helpers from 'helpers';
import {uploadForm} from '../api/file-upload';
import {success, error} from './alertActions';
import {isValidFilename, getInvalidFilenameMessage} from 'helpers/constants';

export const deleteAttachment = (attachmentId, coords = null) => dispatch =>
  asyncDelete({
    dispatch,
    successMessage: 'The file has been deleted successfully.',
    title: 'file',
    url: `/attachments/${attachmentId}?${
      coords ? `latitude=${coords.latitude}&longitude=${coords.longitude}` : ''
    }`,
  });

export const updateAttachment = (attachment, form) => dispatch => {
  const formObject = helpers.formValidation.setupFormBody(form, true);

  if (formObject.hasError) {
    helpers.handleError(formObject.errorMessage, null, dispatch);
    return null;
  }

  return asyncPatch({
    body: formObject.body,
    dispatch,
    successMessage: 'The file has been updated successfully.',
    title: 'file',
    url: `/attachments/${attachment.attachmentId}`,
  });
};

export const uploadAttachment = (
  estimateId,
  files,
  share,
  coords = null,
) => async dispatch => {
  const results = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    // MHD-3605: Validate filename before upload
    if (!isValidFilename(file.name)) {
      dispatch(error(getInvalidFilenameMessage(file.name)));
      continue;
    }

    const data = new FormData();
    data.append('file', file);
    data.append('fileName', file.name);
    data.append('share', share);
    if (coords) {
      data.append('latitude', coords.latitude);
      data.append('longitude', coords.longitude);
    }
    const resp = await uploadForm(`/Estimates/${estimateId}/Attachments`, data);

    if (resp && resp.error) {
      dispatch(error(`${file.name}: unable to upload`));
    } else {
      dispatch(success(`${file.name}: upload success`));
      results.push(resp);
    }
  }
  return results;
};

export const loadPreview = attachmentId => dispatch =>
  asyncLoad({
    url: `/Attachments/${attachmentId}/preview`,
    title: 'File Preview',
    dispatch,
  });

export const downloadFile = attachmentId => dispatch =>
  asyncLoad({
    url: `/Attachments/${attachmentId}/file`,
    params: {raw: true},
    title: 'File',
    dispatch,
  });



// WEBPACK FOOTER //
// ./src/actions/attachmentActions.js